<div class="container">
    <header class="desktop-hide">
        <div class="left">
            <h1>Dashboard</h1>
        </div>

        <div class="right">
            <!-- <button *ngIf="searchCategory!=''" (click)="createItem(searchCategory)" mat-button color="primary">Create {{searchCategory}}</button>
            <button [routerLink]="['/settings/item-template-editor', searchCategory]" mat-icon-button><mat-icon>settings</mat-icon></button> -->
        </div>
    </header>

    <section class="profit-card" *ngIf="!isLoading; else profitLoading">
        <div class="header-row">
            <div>
                <p class="eyebrow">Profit & Loss (Accounts)</p>
                <h3>Revenue vs Expenses</h3>
            </div>
            <div class="pill" [class.positive]="profit>=0" [class.negative]="profit<0">
                {{ profit | human:true }}
            </div>
        </div>
    </section>
    <ng-template #profitLoading>
        <section class="profit-card loading">
            <mat-spinner diameter="36"></mat-spinner>
            <span>Loading profit/loss…</span>
        </section>
    </ng-template>

    <section class="metrics-card">
        <div class="metric" [class.loading]="isLoadingMetrics" [class.active]="selectedRangeDays===7" (click)="selectRange(7)">
            <p class="label">7-day rolling profit</p>
            <p class="value">
              {{ isLoadingMetrics ? '—' : (rollingProfit7 | human:true) }}
              <span class="alt" *ngIf="!isLoadingMetrics && desiredDelta7 !== 0">{{ desiredDelta7 > 0 ? '+' : ''}}{{ desiredDelta7 | human:true }}</span>
            </p>
            <p class="sub">Rev: {{ rollingRevenue7 | human:true }} · Exp: {{ rollingExpense7 | human:true }}</p>
          </div>
        <div class="metric" [class.loading]="isLoadingMetrics" [class.active]="selectedRangeDays===30" (click)="selectRange(30)">
            <p class="label">30-day rolling profit</p>
            <p class="value">
              {{ isLoadingMetrics ? '—' : (rollingProfit30 | human:true) }}
              <span class="alt" *ngIf="!isLoadingMetrics && desiredDelta30 !== 0">{{ desiredDelta30 > 0 ? '+' : ''}}{{ desiredDelta30 | human:true }}</span>
            </p>
            <p class="sub">Rev: {{ rollingRevenue30 | human:true }} · Exp: {{ rollingExpense30 | human:true }}</p>
        </div>
        <div class="metric" [class.loading]="isLoadingMetrics" [class.active]="selectedRangeDays===90" (click)="selectRange(90)">
            <p class="label">90-day rolling profit</p>
            <p class="value">
              {{ isLoadingMetrics ? '—' : (rollingProfit90 | human:true) }}
              <span class="alt" *ngIf="!isLoadingMetrics && desiredDelta90 !== 0">{{ desiredDelta90 > 0 ? '+' : ''}}{{ desiredDelta90 | human:true }}</span>
            </p>
            <p class="sub">Rev: {{ rollingRevenue90 | human:true }} · Exp: {{ rollingExpense90 | human:true }}</p>
        </div>
    </section>

    <section class="chart-card" (wheel)="onChartWheel($event)">
        <div class="chart-header">
            <div>
                <p class="eyebrow">90 day average</p>
                <h4>Trend: {{ avgProfitPerDay | currency:'USD':'symbol':'1.2-2' }} ({{ profitSlopePerDay > 0 ? '+' : '-'}}{{ profitSlopePerDay | human }})</h4>
            </div>
            <button mat-stroked-button color="primary" (click)="toggleRollingAverage()">
                {{ showRollingAverage ? 'Hide' : 'Show' }} rolling avg
            </button>
            <button mat-flat-button color="accent" (click)="zoomToFit()">Zoom to fit</button>
        </div>
        <apx-chart
            *ngIf="trendChartOptions.series"
            [series]="trendChartOptions.series"
            [chart]="trendChartOptions.chart"
            [xaxis]="trendChartOptions.xaxis"
            [yaxis]="trendChartOptions.yaxis"
            [stroke]="trendChartOptions.stroke"
            [markers]="trendChartOptions.markers"
            [tooltip]="trendChartOptions.tooltip"
            [dataLabels]="trendChartOptions.dataLabels"
            [annotations]="trendChartOptions.annotations">
        </apx-chart>
    </section>

    <section class="totals-bar">
        <div class="total-box">
            <p class="label">Revenue ({{selectedRangeDays}}d)</p>
            <p class="value">{{ currentRevenueTotal | human:true }}</p>
        </div>
        <div class="total-box">
            <p class="label">Expenses ({{selectedRangeDays}}d)</p>
            <p class="value">{{ currentExpenseTotal | human:true }}</p>
        </div>
    </section>

    <section class="lists">
        <div class="list-card">
            <div class="list-header">
                <h4>Revenue (last {{selectedRangeDays}} days)</h4>
                <span class="count">{{ recentRevenue7.length }}</span>
            </div>
            <div class="list-body" *ngIf="recentRevenue7.length; else noRev">
                <div class="row clickable" *ngFor="let tx of recentRevenue7" (click)="openReceipt(tx, 'rev')">
                    <div class="left">
                        <div class="title">{{ tx.description || 'Revenue' }}</div>
                        <div class="sub">{{ tx.date | date:'dd MMM' }} · {{ tx.source?.account }}</div>
                    </div>
                    <div class="right">{{ displayExAmount(tx) | human:true }}</div>
                </div>
            </div>
            <ng-template #noRev><p class="empty">No revenue in the last 7 days.</p></ng-template>
        </div>

        <div class="list-card">
            <div class="list-header">
                <ng-container *ngIf="!selectedExpenseCategory; else expenseDetailHeader">
                    <h4>Expenses by category (last {{selectedRangeDays}} days)</h4>
                    <span class="count">{{ recentExpensesByCategory.length }}</span>
                </ng-container>
                <ng-template #expenseDetailHeader>
                    <button mat-icon-button (click)="backToExpenseCategories()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    <h4>{{ selectedExpenseCategory?.label }}</h4>
                    <span class="count">{{ selectedExpenseTransactions.length }}</span>
                </ng-template>
            </div>
            <div class="list-body" *ngIf="!selectedExpenseCategory">
                <ng-container *ngIf="recentExpensesByCategory.length; else noExp">
                    <div class="row clickable" *ngFor="let cat of recentExpensesByCategory" (click)="selectExpenseCategory(cat)">
                        <div class="left">
                            <div class="title">{{ cat.label }}</div>
                            <div class="sub">{{ cat.count }} transactions</div>
                        </div>
                        <div class="right negative">{{ cat.amount | human:true }}</div>
                    </div>
                </ng-container>
            </div>
            <div class="list-body" *ngIf="selectedExpenseCategory">
                <div class="row clickable" *ngFor="let tx of selectedExpenseTransactions" (click)="openReceipt(tx, 'exp')">
                    <div class="left">
                        <div class="title">{{ tx.description || 'Expense' }}</div>
                        <div class="sub">{{ tx.date | date:'dd MMM' }} · {{ tx.source?.account }}</div>
                    </div>
                    <div class="right negative">{{ displayExAmount(tx) | human:true }}</div>
                </div>
            </div>
            <ng-template #noExp><p class="empty">No expenses in the last 7 days.</p></ng-template>
        </div>
    </section>

</div>
